
    <button mat-button color="primary" title="Refresh" class="btn-refresh hide">
      <i class="fa-solid fa-arrows-rotate"></i>
    </button>
    <h3 class="cp-heading">
      <i class="fa-light fa-satellite-dish"></i>Connect to TBA GUI & eCS
    </h3>
    <!-- <p *ngIf="!rootScope.TBAGUIRegistrationUnauthorized && !rootScope.TBAGUIConnected">Status: <strong class="disconnected">Disconnected</strong></p> -->
    <p *ngIf="!rootScope.TBAGUIConnected">Status: <strong class="disconnected">Disconnected</strong></p>
    <!-- CCR6-1872 A condition to be added by Features-->
    <!-- <p>Status: <strong class="processing">Processing...</strong></p> -->
    <p *ngIf="rootScope.TBAGUIConnected">Status: <strong class="connected">Connected</strong></p>
    <p *ngIf="!rootScope.TBAGUIConnected">You must enter your RACF credentials to access TBA GUI and eCS.</p>
    <p *ngIf="rootScope.TBAGUIConnected">You can now access TBAGUI and eCS links from Care Portal.</p>

    <!--Health Check TBA GUI Messgae -->
    <section *ngIf="rootScope.TBAGUIHealthCheckError && !rootScope.TBAGUIConnected" class="error-wrapper">
      <f-alert class="error-without-heading" variant="error">
        <p class="full-width">
          You can not access TBAGUI and eCS links from Care Portal.
        </p>
      </f-alert>
    </section>

    <!--Account Locked Messgae -->
    <section *ngIf="rootScope.TBAGUIAccountLockedError" class="error-wrapper">
      <f-alert class="error-with-heading" variant="error">
        <h4>Your account is locked.</h4>
        <p class="full-width">
          Accounts are locked after too many failed login attempts. Go to
          <a class="link" href="javascript:void('0')" (click)="goToAlightCloud()">myIdentity</a>
          to reset your password.
        </p>
      </f-alert>
    </section>

    <!-- password has expired -->
    <section *ngIf="rootScope.TBAGUIRegistrationPassExpire" class="error-wrapper">
      <!-- Error messgae for password has expired-->
      <f-alert class="error-with-heading" variant="error">
        <h4>Your password has expired.</h4>
        <p class="full-width">
          Go to
          <a class="link" href="javascript:void('0')" (click)="goToAlightCloud()">myIdentity</a>
          to reset your password.
        </p>
      </f-alert>
    </section>

    <!--Password Invalid Messgae -->
    <section *ngIf="rootScope.TBAGUIRegistrationUnauthorized" class="error-wrapper">
      <f-alert class="error-without-heading" variant="error">
        <p class="full-width">
          Your ID or Password is incorrect. Try again.
        </p>
      </f-alert>
    </section>

    <!-- API failure messgae -->
    <section *ngIf="rootScope.TBAGUIRegistrationUnexpectedError" class="error-wrapper">
      <f-alert variant="error">
        <p class="full-width">
          An unexpected error has occured, please try to login again. If
          issue persists contact myIT.
        </p>
      </f-alert>
    </section>

    <!--Password Valid Messgae -->
    <section *ngIf=" rootScope.TBAGUIRegistrationnAuthorized && rootScope.TBAGUIConnected" class="error-wrapper">
      <f-alert variant="success" is-dismissable="true" (dismiss)="closeSuccess()">
        <p>The Care Portal is now connected with TBA GUI & eCS.</p>
      </f-alert>
    </section>
    <form [formGroup]="tbaRegisterForm" (ngSubmit)="onSubmit()">
      <div class="login-container" *ngIf="!rootScope.TBAGUIConnected">
        <mat-form-field appearance="fill" class="component-box">
          <mat-label>RACF ID (Required)</mat-label>
          <input  matInput formControlName="racfId" id='txtracfId' autoCompleteOff />
        </mat-form-field>

        <div>
          <mat-form-field appearance="fill" class="component-box pwd-box">
            <mat-label>Password (Required)</mat-label>
            <input  [type]="inputDataType" autoCompleteOff matInput formControlName="racfPassword" id='txtracfPWD'
              maxlength="8" />
            <f-button *ngIf="hidePwdIcon && accountNotBlocked" [iconConfig]="iconConfigEye" (click)="togglePwdIcon()"
              type="button" variant="ghost" class="eye-btn">
            </f-button>
            <f-button *ngIf="!hidePwdIcon && accountNotBlocked" [iconConfig]="iconConfigEyeSlash"
              (click)="togglePwdIcon()" type="button" variant="ghost" class="eye-btn">
            </f-button>
          </mat-form-field>
        </div>
        <f-button text="Connect" [disabled]="tbaRegisterForm.invalid || disableConnectButton" type="submit"
          variant="progressive" disabled="false" class="full-width-btn">
        </f-button>
        <section *ngIf="rootScope.TBAGUIRegistrationUnauthorized" >
          <p class="full-width tbaguiHelpUrl">
            <a href="javascript:void('0')"
            (click)="this.rootScope.openNewTab(this.tbaguiHelpUrl)">Trouble logging in?</a>
          </p>
       </section>
      </div>

    </form>
  
